export interface ModerationItem {
    itemId: string
    date: number
    author: ModerationUser
    teamId: string
    moderation: { events: ModerationEvent[]; status?: ModerationEventStatus }
    itemType: string
    content: string
    parentId?: string,
    parentType?: string,
}

export interface ModerationEvent {
    icon: string
    timestamp: number
}

interface ModerationRequestEvent extends ModerationEvent {
    icon: string
    timestamp: number
    reason: string
    reporter: ModerationUser
}

interface ModerationResponseEvent extends ModerationEvent {
    icon: string
    timestamp: number
    status: ModerationEventStatus
    moderator: ModerationUser
}

export class ModerationMapper {
    static fromDto(dto: ModerationItemDTO): ModerationItem {
        const moderationEvents: ModerationEvent[] = dto.moderation.events.map(event => {
            return ModerationEventMapper.fromDto(event);
        });

        return {
            itemId: dto.itemId,
            date: dto.date,
            author: dto.author,
            teamId: dto.teamId,
            content: dto.content,
            itemType: dto.itemType,
            moderation: {
                events: moderationEvents,
                status: dto.moderation.status
            },
            parentId: dto.parentId,
            parentType: dto.parentType,
        }
    }
}

const mapToRequestEvent = (dto: ModerationRequestEventDTO): ModerationRequestEvent => ({
    icon: "fa-hexagon-exclamation",
    timestamp: dto.timestamp,
    reason: dto.reason,
    reporter: dto.reporter
})

const mapToResponseEvent = (dto: ModerationResponseEventDTO): ModerationResponseEvent => ({
    icon: getResponseIcon(dto),
    timestamp: dto.timestamp,
    status: dto.status,
    moderator: dto.moderator
})

const getResponseIcon = (dto: ModerationResponseEventDTO) => {
    switch (dto.status.id) {
        case "UnderReviewModerationStatus":
            return "fa-search"
        case "DoneWithFilteredOutModerationStatus":
            return "fa-times"
        case "DoneAndRestoredModerationStatus":
            return "fa-check"
    }
}

class ModerationEventMapper {

    static fromDto(dto: ModerationEventDTO): ModerationEvent {
        switch (dto._type) {
            case "models.ModerationRequestEvent":
                return mapToRequestEvent(dto)
            case "models.ModerationResponseEvent":
                return mapToResponseEvent(dto)
        }
    }
}

export interface ModerationItemDTO {
    itemId: string,
    date: number,
    author: ModerationUser,
    teamId: string,
    moderation: {
        events: ModerationEventDTO[],
        status: ModerationEventStatus
    },
    itemType: "Thread",
    content: string,
    parentId?: string,
    parentType?: string,
}

export type ModerationEventDTO = ModerationRequestEventDTO | ModerationResponseEventDTO

interface ModerationRequestEventDTO {
    _type: "models.ModerationRequestEvent"
    reporter: ModerationUser,
    reason: string,
    timestamp: number
}

interface ModerationResponseEventDTO {
    _type: "models.ModerationResponseEvent"
    moderator: ModerationUser,
    status: ModerationEventStatus,
    timestamp: number
}

interface ModerationEventStatus {
    id: "UnderReviewModerationStatus" | "DoneWithFilteredOutModerationStatus" | "DoneAndRestoredModerationStatus",
    description: "Submitted"
}

interface ModerationUser {
    id: string,
    fullName: string,
    email: {
        value: string
    }
}